import gql from 'graphql-tag';
import { isNil } from 'lodash';
import { getSharedApolloClient } from '@shared/api/client';
import { MBSentry } from '@shared/util/sentry';

const query = gql`
  query FetchMyUserId {
    me {
      id
    }
  }
`;

// TODO: this is a MAJOR hack...
export async function fetchAndInsertUserIdIntoStore(dispatch: MBDispatch) {
  const apolloClient = getSharedApolloClient();
  try {
    // Note: we need to set fetchPolicy to "network-only".
    // Otherwise Apollo throws an error because it's not sure
    // whether to use the cached result or do a network query.
    // This is specific to querying directly. If this were used
    // in a component, Apollo would go to the cache first and
    // then to the network.
    const result = await apolloClient.query({ query, fetchPolicy: 'network-only' });
    const userId = result?.data?.me?.id;
    if (!isNil(userId)) {
      dispatch({ type: 'SET_USER_ID', value: { id: userId } });
    }
  } catch (error) {
    if (error instanceof Error) {
      MBSentry.exception({ error });
    }
    // As long as we fail, wait a while and retry. We really need to get the
    // user's id into the store... 😞
    await new Promise(resolve => setTimeout(resolve, 1000));
    fetchAndInsertUserIdIntoStore(dispatch);
  }
}
